import { render } from "./StarRuleTable.vue?vue&type=template&id=5752d6d9&scoped=true&ts=true"
import script from "./StarRuleTable.vue?vue&type=script&lang=ts"
export * from "./StarRuleTable.vue?vue&type=script&lang=ts"

import "./StarRuleTable.vue?vue&type=style&index=0&id=5752d6d9&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5752d6d9"]])

export default __exports__